import React, { ChangeEvent, useEffect, useState } from 'react'
import { useEditSocialMedia } from './hooks'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormCheck,
  CFormInput,
  CFormSelect,
  CRow,
  CSpinner,
} from '@coreui/react-pro'
import { languages } from '../../../../../libs/languages'
import {
  submitUpdateSocialMedia,
  setSocialMediaForm,
  offersByLangMounted,
} from './model'
import { FileManagerForm } from '../widgets/FileManagerForm/component'
import { initialSocialMediaFile } from '../constants'
import { Flex } from 'antd'
import { SocialMediaFile } from '../list/types'
import { useStore } from 'effector-react'
import { $offersByLang } from './model'
import { getOffers } from '../../offers/list/model'
import { uniqueId } from 'lodash'

const mock = {
  id: 19,
  socialMediaId: 1,
  previewPath: '/ib-materials/social-media/bonus111/ar/bonus111_ar_1.png',
  originPath: '/ib-materials/social-media/bonus111/ar/bonus111_ar_1.png',
  platforms: ['facebook', 'instagram', 'telegram'],
  format: 'image',
  fName: 'bonus111_ar_1.png',
  fExtension: 'png',
  fDimensions: '1200x628',
  fSize: 787664,
  isVisible: true,
}

export const EditSocialMedia: React.FC = () => {
  const [validated, setValidated] = useState(false)

  const { socialMedia, loading } = useEditSocialMedia()

  const offersByLang = useStore($offersByLang)
  const offersByLangLoading = useStore(getOffers.pending)

  const [socialMediaFiles, setSocialMediaFiles] = useState<
    SocialMediaFile[] | []
  >([])

  const handleChange = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const targetName = event.currentTarget.name
    let value

    if (event.currentTarget.type === 'checkbox') {
      value = (event.currentTarget as HTMLInputElement).checked
    } else {
      value = event.currentTarget.value
    }

    if (targetName === 'lang') {
      offersByLangMounted({ lang: socialMedia.lang })
      setSocialMediaForm({
        ...socialMedia,
        offerId: 0,
        [event.currentTarget.name]: value,
      })
    } else {
      setSocialMediaForm({
        ...socialMedia,
        [event.currentTarget.name]: value,
      })
    }
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const form = event.currentTarget

    if (!form.checkValidity()) {
      event.preventDefault()
      event.stopPropagation()
    } else {
      submitUpdateSocialMedia({
        lang: socialMedia.lang,
        title: socialMedia.title,
        isVisible: socialMedia.isVisible,
        offerId: Number(socialMedia.offerId),
      })
      event.preventDefault()
      event.stopPropagation()
    }
    setValidated(true)
  }

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <CSpinner />
      </div>
    )
  }

  return (
    <CCard className="mb-4">
      <CCardHeader className="d-sm-flex justify-content-between align-items-center">
        <strong>Edit social media</strong>
      </CCardHeader>
      <CCardBody>
        <CForm noValidate validated={validated} onSubmit={handleSubmit}>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CFormInput
                type="text"
                name="title"
                value={socialMedia.title}
                onChange={handleChange}
                label="Name"
                minLength={3}
                maxLength={30}
                required
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CFormSelect
                label="Language"
                name="lang"
                value={socialMedia.lang}
                onChange={handleChange}
              >
                {languages.map((language) => (
                  <option key={language.value} value={language.value}>
                    {language.label}
                  </option>
                ))}
              </CFormSelect>
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol sm={4}>
              {offersByLangLoading ? (
                <CSpinner color="primary" />
              ) : (
                <CFormSelect
                  label="Offer"
                  name="offerId"
                  value={socialMedia.offerId}
                  onChange={handleChange}
                >
                  <option>Choose offer</option>
                  {offersByLang?.map((offer) => (
                    <option key={offer.id} value={offer.id}>
                      {offer.title}
                    </option>
                  ))}
                </CFormSelect>
              )}
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol sm={2}>
              <CFormCheck
                name="isVisible"
                checked={socialMedia.isVisible}
                onChange={handleChange}
                label="Active"
              />
            </CCol>
            <CCol sm={4}>
              <CButton
                className="me-3"
                onClick={() => {
                  setSocialMediaFiles((prev) => [
                    ...prev,
                    initialSocialMediaFile,
                  ])
                }}
              >
                Added file
              </CButton>
              <CButton
                style={{
                  width: '100px',
                }}
                type="submit"
              >
                Save
              </CButton>
            </CCol>
          </CRow>
        </CForm>
        <div className="mb-3">
          <strong>Files</strong>
        </div>
        <Flex gap={40} wrap="wrap">
          <>
            {socialMedia?.socialMediaFiles.map((item) => (
              <FileManagerForm key={item.id} mode={'edit'} data={item} />
            ))}
            {socialMediaFiles?.map((item, index) => (
              <FileManagerForm key={uniqueId()} mode={'create'} data={item} />
            ))}
          </>
        </Flex>
      </CCardBody>
    </CCard>
  )
}
